import styled from 'styled-components'

interface SwitchProps {
  isOn: boolean
  handleToggle: () => void
}

const Switch = ({ isOn, handleToggle }: SwitchProps) => {
  return (
    <SwitchContainer
      aria-label="switch-button"
      onClick={handleToggle}
      $isOn={isOn}
    >
      <SwitchTextLeft $isOn={isOn}>Solo</SwitchTextLeft>
      <SwitchCircle $isOn={isOn} />
      <SwitchTextRight $isOn={isOn}>Team</SwitchTextRight>
    </SwitchContainer>
  )
}

const SwitchContainer = styled.button<{ $isOn: boolean }>`
  width: 100%;
  height: 30px;
  background: ${({ $isOn }) =>
    $isOn
      ? 'linear-gradient(to bottom right, rgb(35,188,186), rgb(0,229,166))'
      : 'linear-gradient(to bottom right, rgb(35,188,186), rgb(0,229,166))'};
  border-radius: 30px;
  cursor: pointer;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 0.75rem 3rem;
  transition: background 0.2s;
  z-index: 0;
`

const SwitchCircle = styled.div<{ $isOn: boolean }>`
  width: 10rem;
  height: 2.75rem;
  background: white;
  border-radius: 30px;
  transition: transform 0.2s;
  z-index: 1;
  transform: ${({ $isOn }) =>
    $isOn ? 'translateX(120px)' : 'translateX(-110px)'};
`

const SwitchTextLeft = styled.span<{ $isOn: boolean }>`
  color: ${({ $isOn }) =>
    $isOn
      ? 'white'
      : 'linear-gradient(to bottom right, rgb(35,188,186), rgb(0,229,166))'};
  user-select: none;
  z-index: 2;
`
const SwitchTextRight = styled.span<{ $isOn: boolean }>`
  color: ${({ $isOn }) =>
    $isOn
      ? 'linear-gradient(to bottom right, rgb(35,188,186), rgb(0,229,166))'
      : 'white'};
  user-select: none;
  z-index: 2;
`

export default Switch
